export default "__VITE_ASSET__oV4TZAv8__"